module.exports = ".pad-bottom{\r\n\tpadding-bottom: 10px;\r\n}"